<template>
	<div
		ref="howToPlayCard"
		data-name="card-wrapper"
		id="howToPlayCard"
		:class="$style.wrapper"
	>
		<div
			v-if="icon"
			data-name="icon-wrapper"
			:class="$style['icon-wrapper']"
		>
			<div :class="$style['icon-container']">
				<img
					:class="$style.icon"
					:src="icon"
					:alt="title + ' SVG Icon'"
					:aria-label="title + ' SVG Icon'"
				/>
			</div>
		</div>

		<div
			data-name="content-wrapper"
			:class="$style['content-wrapper']"
		>
			<h1
				:class="$style['content-header']"
				v-if="title"
			>{{ title }}</h1>
			<ol
				data-name="instructions"
				:class="$style.instructions"
				v-if="instructions"
			>
				<template v-for="(item,index) in instructions">
					<li
						data-name="instruction"
						:class="$style.instruction"
						v-html="item"
					></li>
				</template>
			</ol>
		</div>

		<div
			data-name="button-wrapper"
			:class="$style['button-wrapper']"
		>
			<div
				v-if="button"
				data-name="button-container"
				:class="$style['button-container']"
				class="orange-button"
			>
				<ui-button
					id="confirmInstructionsButton"
					:buttonText="button"
					:buttonAction="handleInstructionConfirmation"
					v-touch.native="handleInstructionConfirmation"
				></ui-button>
			</div>
		</div>
	</div>
</template>

<script>
import UiButton from "../UiButton";
import isMobileMixin from "../../plugins/isMobileMixin.js";
import tweenSpeedsMixin from "../../plugins/tweenSpeedsMixin.js";
import { TweenMax, TimelineMax } from "gsap";
import axios from "axios";

export default {
	name: "how-to-play-card",
	mixins: [isMobileMixin, tweenSpeedsMixin],
	components: {
		"ui-button": UiButton
	},
	data() {
		return {
			title: "",
			instructions: [],
			button: "",
			icon: "",
			isCardOpen: false
			// tweenSpeeds: {
			//   cardShow: 0.6
			// }
		};
	},
	beforeCreate() {
		axios.get("/static/info.json").then(response => {
			this.title = response.data.howtoplay.title;
			this.instructions = response.data.howtoplay.instructions;
			this.button = response.data.howtoplay.button;
			this.icon = response.data.howtoplay.icon;
		});
	},
	mounted() {
		// debugger;
	},
	computed: {
		appState: function() {
			return this.$store.getters.getAppState;
		}
	},
	watch: {
		appState(state, oldState) {
			if (state === "instruction") {
				this.handleCardOpen();
			} else if (this.isCardOpen) {
				this.handleCardClose();
			}
		}
	},
	methods: {
		handleCardOpen: function() {
			this.isCardOpen = true;

			if (this.isMobile) {
				TweenMax.fromTo(
					`.${this.$style.wrapper}`,
					this.tweenSpeeds.dur.cardShow,
					{
						opacity: 0,
						y: "0%",
						ease: this.tweenSpeeds.ease.global
					},
					{
						opacity: 1,
						y: "-100%",
						ease: this.tweenSpeeds.ease.global
					}
				);
			} else {
				TweenMax.to(
					`.${this.$style.wrapper}`,
					this.tweenSpeeds.dur.cardShow,
					{
						right: 0,
						ease: this.tweenSpeeds.ease.global
					}
				);
			}

			TweenMax.set(`.${this.$style.wrapper}`, {
				pointerEvents: "inherit"
			});
		},
		handleCardClose: function() {
			this.isCardOpen = false;

			if (this.isMobile) {
				TweenMax.fromTo(
					`.${this.$style.wrapper}`,
					this.tweenSpeeds.dur.cardShow,
					{
						opacity: 1,
						y: "-100%",
						ease: this.tweenSpeeds.ease.global
					},
					{
						opacity: 0,
						y: "0%",
						ease: this.tweenSpeeds.ease.global
					}
				);
			} else {
				TweenMax.to(
					`.${this.$style.wrapper}`,
					this.tweenSpeeds.dur.cardShow,
					{
						right: "-100%",
						ease: this.tweenSpeeds.ease.global
					}
				);
			}

			TweenMax.set(`.${this.$style.wrapper}`, {
				pointerEvents: "none"
			});
		},
		handleInstructionConfirmation: function() {
			if (this.isMobile) {
				this.$store.dispatch("updateAppState", {
					state: "playing"
				});
			} else {
				// this.$store.dispatch("updateAppState", {
				// 	state: "playing-show-card"
				// });
				// this.$store.dispatch("updateAppState", {
				// 	state: "playing"
				// });
			}

			this.$emit("instructionsConfirmed");
		}
	}
};
</script>

<style lang='scss' module>
@import "../../assets/css/globals.scss";

* {
	// outline: 1px solid red;
}

.wrapper {
	position: relative;

	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin-right: auto;
	margin-left: auto;
	margin-top: -32px;

	width: 80%;
	max-width: 600px;

	border-radius: 15px;

	color: white;

	background-color: white;

	box-shadow: 0px 2px 30px -1px rgba(0, 0, 0, 0.25);

	z-index: 500;

	opacity: 0;
	pointer-events: none;

	@include large {
		position: absolute;
		right: -100%;
		margin-top: 0;

		top: 0;

		justify-content: space-between;

		border-radius: 0;

		height: 100vh;
		width: 40%;

		opacity: 1;

		box-shadow: none;
	}

	@include nateLarge {
		width: 30%;
	}
}

.content-wrapper {
	padding: 30px;
	color: black;

	@include xxlarge {
		padding-left: 60px;
		padding-right: 60px;
	}
}

.content-header {
	margin-top: 0;
	margin-bottom: 20px;
}

.instructions {
	margin: 0;
	padding-left: 20px;
	list-style-position: outside;

	color: $emperor;
}

.instruction {
	padding-left: 10px;
	line-height: 1.4;
	font-weight: 300;

	&:not(:last-child) {
		padding-bottom: 30px;
	}
}

.content-sub-text {
	line-height: 30px;
	color: RGBA(85, 85, 85, 1);
}

.icon-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;

	padding-top: 30px;
	padding-right: 30px;
	padding-bottom: 0px;
	padding-left: 30px;

	@include large {
		margin-top: 100px;
	}
}

.icon-container {
	display: flex;
	justify-content: center;
	align-items: center;

	width: 70px;
	height: 70px;

	border-radius: 50%;
	background-color: rgba($mantis, 0.1);

	@include large {
		width: 70px;
		height: 70px;
	}

	@include nateLarge {
		width: 150px;
		height: 150px;
	}
}

.icon {
	width: 70px;
	height: 70px;

	@include large {
		width: 70px;
		height: 70px;
	}

	@include nateLarge {
		width: 150px;
		height: 150px;
	}
}

.button-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	// width: 100%;

	width: 100%;
	height: 75px;

	// padding: 30px;
	padding-top: 30px;
	padding-bottom: 30px;

	border-top: 2px solid RGBA(52, 108, 172, 0.05);

	font-weight: bold;

	@include large {
		width: 100%;

		margin-top: auto;
	}
}

.button-container {
	width: 220px;
	height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/HowToPlayCard.vue